/**
 * RW-3278 — /sign/<slug> is the page clients sign on: no login, no app shell.
 * The slug is DocuSeal's per-signer code and works as the signing link, so
 * on this page nothing may report the URL: no analytics, no error logging,
 * no service worker (see index.js and firebase.js).
 *
 * RW-3293: Rêve Sign's own pages live under /sign too (/sign/envelopes,
 * /sign/templates, …). They're lowercase words; a DocuSeal slug is a random
 * mixed-case code (e.g. PxamYETgvq1YXM). So a slug must carry a capital
 * letter or a digit, and must not be one of the app's own route names —
 * otherwise a refresh of /sign/envelopes rendered the client signing page.
 */
const CLIENT_SIGN_RE = /^\/sign\/([A-Za-z0-9_-]{6,80})\/?$/;
const LOOKS_LIKE_SLUG = /[A-Z0-9]/;
// Rêve Sign's one-segment routes (SignApp). Lowercase today, listed anyway so a
// future route with a digit in it can't be taken for a signing link.
export const APP_SIGN_ROUTES = new Set(['envelopes', 'envelope', 'templates', 'settings', 'verdicts', 'inbox']);

/** The signer's slug when `pathname` is the client signing page, else null. */
export function clientSignSlug(pathname) {
  const m = CLIENT_SIGN_RE.exec(String(pathname || ''));
  if (!m) return null;
  const slug = m[1];
  if (!LOOKS_LIKE_SLUG.test(slug) || APP_SIGN_ROUTES.has(slug.toLowerCase())) return null;
  return slug;
}

export const isClientSignPage = () => typeof window !== 'undefined' && clientSignSlug(window.location.pathname) !== null;
